var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import FullFooter from "./components/FullFooter";
import MinimalFooter from "./components/MinimalFooter";
import "./TravellerFooter.types";
export var checkMinimalFooter = function (props) {
    return props.variant === "minimal";
};
var TravellerFooter = function (props) {
    return checkMinimalFooter(props) ? (React.createElement(MinimalFooter, __assign({}, props))) : (React.createElement(FullFooter, __assign({}, props)));
};
export default TravellerFooter;
